
<template>
  <div>
    <v-card>
      <v-row class="pa-3" v-if="componenteEvento.agregar_submodulo">
        <v-spacer></v-spacer>
        <ButtonComp @click="addItem" textButton="Agregar documento requerido" normalButton iconBut="fas fa-plus" />
      </v-row>

      <ComundataTablecompVue :headers="DocumentosRequeridosHeaders" :items="documentos" :search="search" whitSearch
        noResultsText="Sin datos para mostrar">

        <template v-slot:activo="{ item }">
          <v-chip v-if="item.activo == true" small dark class="font-weight-black" color="green">ACTIVO</v-chip>
          <v-chip v-else small dark class="font-weight-black" color="red">INACTIVO </v-chip>
        </template>


        <template v-slot:action_editar="{ item }">
          <ButtonComp v-if="componenteEvento.editar_submodulo" @click="editItem(item)" editButton
            tooltipText="Editar documento" />
        </template>


        <template v-slot:action_borrar="{ item }">
          <ButtonComp v-if="componenteEvento.borrar_submodulo" @click="deleteConfirm(item)"
            tooltipText="Eliminar documento" deleteButton />
        </template>
      </ComundataTablecompVue>
    </v-card>
    <!--  FIN lIST DE REGISTROS --->



    <!-- modal para crear/editar admisiones -->
    <v-form ref="formDatos" v-model="validdocs" lazy-validation>
      <ComunDialogComp v-model="dialog" maxWidth="700" @close-modal="dialog = false" :title="formTitle">
        <template v-slot:body>
          <v-row>
            <!-- {{admisiones}} -->
            <v-col md="8" v-if="evento == 'editar'">
              <textfieldComp v-model="editedItem.ano_academico" textLabel="Año académico" :disabled="!bloquearCampo"
                :rules="validationRules.validateCampo" />

            </v-col>
            <v-col md="8" v-else>
              <AutocompleteComp v-model="editedItem.ano_academico" textLabel="Año académico"
                :items="parametros.admisiones" item-value="value" item-text="ano_academico"
                :rules="validationRules.validateCampo" />
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <textfieldComp v-model="editedItem.desc_documentos_requeridos" textLabel="Documento requerido"
                hint="Descripción del Encabezado" :rules="validationRules.validateCampo" />
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <ButtonComp v-if="evento == 'editar'" @click="editAdmision(editedItem.id)" textButton="Guardar cambios"
            iconBut="fas fa-save" normalButton />
          <ButtonComp v-if="evento == 'agregar'" @click="addAdmision" textButton="Guardar" iconBut="fas fa-save" normalButton/>
        </template>
      </ComunDialogComp>

    </v-form>
    <!--------->




    <ComunDialogComp v-model="dialog_confirm" titleWindow="Confirmar" Confirmdialog @close-modal="dialog_confirm = false"
      @confirm-item="funcionConfirm('si')" @cancel-item="funcionConfirm('no')">
      <template v-slot:body>
        {{ desc_confirm }}<br/>
        {{ name_confirm }}
      </template>
    </ComunDialogComp>
    <ComunDialogComp v-model="dialog_delete" titleWindow="Eliminar documento" Deletedialog
      @close-modal="dialog_delete = false" @delete-item="funcionConfirm('si')" @cancel-item="funcionConfirm('no')">
      <template v-slot:body>
        ¿Está seguro de eliminar este registro?
        <br/>
        {{ desc_confirm }}
        <br/>
        {{ name_confirm }}
      </template>
    </ComunDialogComp>

    <!-- //////////////Modal para confirmar eliminacion /////////////////////    -->

    <!-- fin de modal de borrar registro -->


  </div>
</template>
  
  
<script>
import axios from "../../../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import ComundataTablecompVue from "@/components/ComponentsEst/ComundataTablecomp.vue"
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
import textfieldComp from '../../../../components/ComponentsEst/textfieldComp.vue';
import { DocumentosRequeridosHeaders } from '../../../../helpers/headersTable';
import { validationRules } from '../../../../helpers/validatorHelpers';


export default {
  name: "Configuracion",
  props: {
    parametros: {
      type: Object,
      default: Object,
    },
  },
  components: {  ComundataTablecompVue, AutocompleteComp, ButtonComp, ComunDialogComp, textfieldComp },

  data: () => ({
    validdocs: true,
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 141, id_modulo: 5 }, //sud_modulo y modulo

    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    bloquearCampo: false,
    DocumentosRequeridosHeaders,
    editedItem: {
      ano_academico: '2025',
    },
    search: "",

    documentos: [],

    //validaciones de formulario

    // modal agregar editar admision
    dialog: false,
    evento: "",


    // modal confirmacion
    name_confirm: "",
    id_delete: null,
    dialog_confirm: false,
    dialog_delete: false,
    desc_confirm: "",
    eventoConfirm: "",
    //////////////////////////////////
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    formTitle() {
      return this.evento === "agregar"
        ? "Agregar documento"
        : this.evento === "ver"
          ? ""
          : "Editar documento";
    },
    validationRules() {
      return validationRules;
    }
  },

  created() {
    this.actualizarParamentro();
    this.getDocumentos();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    ////////  METODO QUE LIMPIA EL FORMULARIO Y VARIABLES /////////
    async limpiarForm() {
      this.editedItem = {
        id: 0,
        id_colegio: this.datoLogin.id_colegio,
        ano_academico: "",
        encabezado: "",
        activo: true,
        id_usuario: this.datoLogin.id,
      };
      this.$refs.formDatos.resetValidation();
    },

    async getDocumentos() {
      try {
        let response = await axios.get(`/admision/documentosRequeridos/${this.datoLogin.id_colegio}`);
        this.documentos = response.data;
        console.log(this.documentos);
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null })
      }
    },

    //////// METODO PARA HABILITAR MODAL PARA AGREGAR UN ITEM NUEVO //
    addItem() {
      this.getDocumentos();
      this.evento = "agregar";
      this.limpiarForm();
      this.bloquearCampo = false;
      this.dialog = true;
    },

    //----------Crear Nueva Requerido ---------------
    async addAdmision() {
      if (this.$refs.formDatos.validate() == true) {
        let params = {
          desc_documentos_requerido: this.editedItem.desc_documentos_requeridos,
          attachments: false,
          ano_academico: this.editedItem.ano_academico,
          id_colegio: this.parametros.admisiones[0].id_colegio,
        };


        try {
          let response = await axios.post(
            "/admision/documentosRequeridos",
            params
          );


          if (response.data.messageT == "S") {
            this.getDocumentos();

            this.agregarOtroDocumento();
          }

          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
        } catch (e) {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de ingresar todos los campos requeridos`,
          tiempo: null,
        });
      }
    },


    //---------------- Editar Admision ----------------
    async editAdmision(id) {
      let params = this.editedItem;
     
      if (this.$refs.formDatos.validate()) {
        try {
          let response = await axios.put(`/admision/documentosRequeridos/${id}`, params);
          if (response.data.messageT == "S") {
            this.$emit("get-admisiones");
            this.dialog = false;
            this.limpiarForm();
            this.getDocumentos();
          }
          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
        } catch (e) {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de ingresar todos los campos requeridos`,
          tiempo: null,
        });
      }
    },

    agregarOtroDocumento() {
      this.eventoConfirm = "agregarOtroDocumento";
      this.dialog_confirm = true;

      this.desc_confirm = "¿Desea agregar otro documento?";
    },

    //------------FUNCION CONFIRMAR -------------
    async funcionConfirm(resp) {
      if (resp == "si" && this.eventoConfirm == "borrar") {
        this.deleteAdmision();
      } else if (resp == "no" && this.eventoConfirm == "borrar") {
        this.dialog_confirm = false;
        this.dialog_delete = false;
      } else if (resp == "si" && this.eventoConfirm == "agregarOtroDocumento") {
        this.dialog_confirm = false;
        this.dialog_delete = false;
        this.limpiarForm();
        this.$refs.formDatos.resetValidation();
      } else {
        this.dialog_confirm = false;
        this.dialog_delete = false;
        this.dialog = false;
      }
    },


    //---------obtener datos pàra editar
    editItem(item, ver = false) {
      this.limpiarForm();
      this.evento = ver == true ? "ver" : "editar";
      this.editedItem = Object.assign({}, item);
      
      this.editedItem.ano_academico = item.ano_academico

      this.dialog = true;

    },

    // *****  confirmar el eliminar **********
    deleteConfirm(item) {
      this.eventoConfirm = "borrar";
      this.dialog_delete = true;
      this.id_delete = item.id;
      this.name_confirm = `Admisión: ${item.ano_academico} (${item.id})`;
      this.desc_confirm = `${item.desc_documentos_requeridos}`;
    },

    //------------ borrar admisión -------------
    async deleteAdmision() {
      try {
        let response = await axios.delete(
          `/admision/documentosRequeridos/${this.id_delete}`
        );
        this.dialog_confirm = false;
        this.dialog_delete = false;

        if (response.data.messageT == "S") {
          this.$emit("get-admisiones");
          this.getDocumentos();
        }

        this.setEnviarMens({
          tipo: response.data.messageT,
          mensaje: response.data.message,
          tiempo: null,
        });
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },
  },
};
</script>
  
  
  
  
<style scoped>
.chip {
  width: 100%;
  height: 100%;
  text-align: center;
  padding-top: 15px;
  color: #ffffff;
}
</style>